import classNames from 'classnames'
import React from 'react'

import { useToggleAnimation } from '~/hooks/useToggleAnimation'
import { type LogoProps } from '~/utils'

import { svgUrl } from '../../utils'

import styles from './Logo.css'

export const Logo = ({ expanded = false }: LogoProps) => {
  const [animationClassName, handleAnimationEnd] = useToggleAnimation(
    expanded,
    [styles.collapsed, styles.expand, styles.expanded, styles.collapse],
  )

  return (
    <div
      className={classNames(styles.root, animationClassName)}
      onAnimationEnd={handleAnimationEnd}
    >
      <img alt="logo" className={styles.imgBase} src={svgUrl('logo-base')} />

      <img
        alt="logo"
        className={styles.imgExtend}
        src={svgUrl('logo-extend')}
      />
    </div>
  )
}
